<template>
    <div class="modal show" id="numberRegistration_popup">
        <div class="modal_box">
            <p class="modal_title">
                {{ $store.getters.getInfoModalText }}
            </p>
            <div class="modal_btnbox">
                <button type="button" class="btn close_btn" @click="closeModal">확인</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useStore } from "vuex";
let store = useStore();
const closeModal = () => {
    store.commit('closeInfoModal');
}
</script>

<style scoped></style>